module.exports = __webpack_public_path__ + "img/Zugtruppführer.419b7b97.svg";